@if (details.formulasAndOptionsInformations.formulaCode === package.Essentielle) {
  <p-divider type="solid"></p-divider>
}

<div>
  <span class="font-app-bold text-darkest text-sm md:text-base">
    {{ "housingSection.title" | translate }}
  </span>
</div>
<div class="flex justify-between mt-3 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "housingSection.address" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.address }}
  </span>
</div>
<div class="flex justify-between mt-3 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "housingSection.address2" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.addressCompl || "-" }}
  </span>
</div>
<div class="flex justify-between mt-3 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "housingSection.postalCode" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.postalCode }}
  </span>
</div>
<div class="flex justify-between mt-3 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "housingSection.city" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.city }}
  </span>
</div>
<div *ngIf="details.formulasAndOptionsInformations.formulaCode === package.Solidaire">
  <div *ngFor="let item of details.riskItemInformations.values">
    <div
      *ngIf="item.code === riskItemInfo.NOM_BAILLEUR"
      class="flex justify-between mt-3 text-sm">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "housingSection.lessorName" | translate }}
      </span>
      <span class="font-app-regular text-darkest text-sm md:text-base">
        {{ item.value }}
      </span>
    </div>
  </div>
</div>
<ng-container *ngFor="let item of riskItems">
  <div class="flex justify-between mt-3 text-sm">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ item!.label | translate }}
    </span>
    <span class="text-sm md:text-base font-app-regular text-darkest">
      {{ item.value | stringToBoolean | booleanToTranslation | translate }}
    </span>
  </div>
</ng-container>
<p-divider type="solid"></p-divider>
